module.exports = __webpack_public_path__ + "img/ZW.9ae924da.png";